import reassign from './reassign';
import add_contact from './add_contact';

export default {
  search: {
    title: 'Search',
    placeholder: 'Search message',
  },
  resolved: {
    resolved: 'Mark as resolved',
    unresolved: 'Unmark as resolved',
  },
  favorite: {
    favorite: 'Add to favorites',
    unfavorite: 'Remove from favorites',
  },
  reassign,
  add_contact,
  export: {
    title: 'Export history',
  },
}
